import { createSlice } from "@reduxjs/toolkit";

const copySettingSlice = createSlice({
  name: "copySettingSlice",
  initialState: {
    appActivityData: null,
    callSmsDetailData: null,
  },
  reducers: {
    setCallSmsData: (state, action) => {
      state.callSmsData = action?.payload;
    },
    setCallSmsDetailData: (state, action) => {
      state.callSmsDetailData = action?.payload;
    },
    clearCopySetting: (state, action) => {
      state.appActivityData = null;
      state.callSmsDetailData = null;
    }
  },
});

// this is for dispatch
export const { setCallSmsData, setCallSmsDetailData, clearCopySetting } =
  copySettingSlice.actions;

// this is for configureStore
export default copySettingSlice.reducer;
